<div class="container">
  <div class="card-list-container">
    <div class="card-container" *ngFor="let product of products"
         [ngClass]="productClassChecker(product)" (click)="setSelectedProduct(product)">
      <div class="card-box">
        <div class="card-desc">
          <div class="card-image" [ngStyle]="{'background-image': 'url(./assets/svg/'+product.short+'.svg)'}"></div>
          <div class="card-icon">
            <img [src]="'./assets/svg/' + product.short +  '_icon.svg'">
          </div>
          <div class="card-name">
            {{product.name}} 
          </div>
        </div>
        <div class="card-details">
          <div class="details-container">
            <!-- Begin Dyed Diesel-->
            <div class="detail-box" *ngIf="product.children.length > 1">
              <div class="detail-title">{{'REQUEST.FUEL.TYPETEXT' | translate}}</div>
              <div class="detail-options">
                <ul class="radio-btns">
                  <li [ngClass]="{active: productForm.value.fuelTypeID == type.id}"
                      *ngFor="let type of product.children"
                      [ngStyle]="{width: 100/product.children.length+ '%'}"
                      (click)="selectFuelType(type)">
                    <span>{{type.name}}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- End Dyed Diesel-->
            <!-- Begin Rec 90-->
            <div class="detail-box">
              <div class="detail-title">{{'REQUEST.FUEL.GALLONSTEXT' | translate}}</div>
              <div class="detail-options">
                  <input class="w-input" [placeholder]="'REQUEST.FUEL.GALLONSPALCEHOLDER' | translate"
                         [title]="'REQUEST.FUEL.GALLONSTEXT' | translate" [(ngModel)]="amount"
                         (change)="checkAmount()" (input)="amountChange($event)" (keypress)="numberOnly($event)"
                         maxlength="5">
              </div>
            </div>
            <!-- End Rec 90-->
            <div class="detail-box">
              <div class="detail-title">{{'REQUEST.FUEL.FILLTEXT' | translate}}</div>
              <div class="detail-options">
                <ul class="radio-btns">
                  <li [ngStyle]="{width: '50%'}" (click)="setFillUp('Fill up my tank')"
                      [ngClass]="{active: productForm.value.fillUp == 'Fill up my tank'}">
                    <span>{{'REQUEST.FUEL.FILLUP' | translate}}</span>
                  </li>
                  <li [ngStyle]="{width: '50%'}" (click)="setFillUp('Stop at the amount')"
                      [ngClass]="{active: productForm.value.fillUp == 'Stop at the amount'}">
                    <span>{{'REQUEST.FUEL.STOPAT' | translate}}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="detail-box">
              <div class="detail-title">{{'REQUEST.FUEL.DATETEXT' | translate}}</div>
              <div class="detail-options">
                <span class="date-text" (click)="selectDate()">
                  <span *ngIf="productForm.value.deliveryDate">{{productForm.value.deliveryDate}}</span>
                  <span *ngIf="!productForm.value.deliveryDate">{{'REQUEST.FUEL.SELECTDATE' | translate}}</span>
                </span>
              </div>
            </div>
            <div class="detail-box">
              <div class="detail-title">{{'REQUEST.FUEL.TIMETEXT' | translate}}</div>
              <div class="detail-options">
                <ul class="multi-select-btns">
                  <li [ngStyle]="{width: '25%'}" *ngFor="let day of dayHours" (click)="selectHour(day.short)">
                    <div class="selector"
                         [ngClass]="{active: selectedHours.indexOf(day.short) != -1, inactive: disabledHours.indexOf(day.short) != -1}">
                      <span>{{'TIME.' + day.name | translate}}</span>
                    </div>
                  </li>
                  <li [ngStyle]="{width: '25%'}" (click)="selectHour('all')">
                    <div class="selector" [ngClass]="{active: selectedHours.length+disabledHours.length == 3}">
                      <span>{{'TIME.ANYTIME' | translate}}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="detail-box no-b-margin">
              <div class="detail-options">
                <button class="w-btn submit-btn" (click)="submitStep()"
                        [disabled]="!productForm.valid || !selectedHours.length">
                  {{'NEXT' | translate}}
                </button>
                <button class="w-link-btn" (click)="setSelectedProduct(null)">{{'TAKEMEBACK' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
